export default __webpack_public_path__ + "static/media/indian-textile-journal.d182b93a.png";